import { FC } from "react";
import { FileList } from "@jasper/shared";
import {
  Box,
  Container,
  Flex,
  Space,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import {
  FileType,
  GetManyOrdersOfUserQuery,
  GetOrderByUniqueAttributeQuery,
} from "/@/generated/graphql";
import { IconCloudUpload, IconX } from "@tabler/icons-react";
import { Dropzone } from "@mantine/dropzone";
import { useOrderFilesManagement } from "./useOrderFilesManagement";

type OrderFilesManagementProps = {
  order:
    | GetOrderByUniqueAttributeQuery["getOrderByUniqueAttribute"]
    | GetManyOrdersOfUserQuery["getManyOrdersOfUser"][0];
  closeModal?: () => void;
};

export const OrderFilesManagement: FC<OrderFilesManagementProps> = ({
  order,
  closeModal = () => null,
}) => {
  const theme = useMantineTheme();
  const { qrCodeCanvasRef, files, uploadFiles, deleteFile, downloadFile } =
    useOrderFilesManagement({ order });

  return (
    <Box
      style={() => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      })}
    >
      <Flex w="100%" justify="right">
        <IconX
          onClick={closeModal}
          style={{ cursor: "pointer" }}
          color={theme.colors.red[5]}
        />
      </Flex>
      <Title
        order={2}
        style={theme => ({
          color: theme.colors.primary[5],
        })}
      >
        Fichiers de la commande {order.orderReference}
      </Title>
      <Space h="sm" />
      <p
        style={{
          textAlign: "center",
          margin: "0",
        }}
      >
        Ajoutez des photos
        <br />
        via ce QR Code
      </p>
      <canvas
        ref={qrCodeCanvasRef}
        style={{
          margin: "auto",
          maxWidth: "200px",
          maxHeight: "200px",
        }}
      />
      <Flex
        direction="row"
        justify="center"
        align="center"
        w="30%"
        // style={theme => ({backgroundColor: theme.colors.primaryLight[8]})}
      >
        <Dropzone
          onDrop={droppedFiles => uploadFiles(droppedFiles)}
          onReject={rejectedFiles =>
            console.log("rejected files", rejectedFiles)
          }
          maxSize={3 * 1024 ** 2}
          style={() => ({
            height: "fit-content",
            width: "fit-content",
            border: 0,
          })}
        >
          <Flex justify="center" align="center">
            <IconCloudUpload />
            <Box ml="sm">
              <Text
                size="sm"
                style={{
                  fontWeight: "bold",
                }}
              >
                {" "}
                {"Ajoutez des fichiers à votre commande"}
              </Text>
            </Box>
          </Flex>
        </Dropzone>
      </Flex>
      <Space h="md" />
      <Container
        p="md"
        style={theme => ({
          backgroundColor: theme.colors.primaryLight[9],
          minHeight: "30%",
          minWidth: "50%",
          maxWidth: "fit-content",
          borderRadius: theme.radius.md,
        })}
      >
        {files.length === 0 ? (
          <Title
            order={3}
            style={{
              fontWeight: "normal",
              textAlign: "center",
            }}
          >
            Aucun fichier pour cette commande
          </Title>
        ) : (
          <FileList
            files={files}
            deleteOneFile={deleteFile}
            downloadOneFile={downloadFile}
            deleteFilter={[FileType.OrderAddonFile]}
            showDate={true}
          />
        )}
      </Container>
      <Space h="md" />
    </Box>
  );
};
